import GatewayAuthenticatorBase from './GatewayAuthenticatorBase';
import { gatewayConstants } from '../AuthConstants';
import { AuthenticationData } from './Definitions';
import FormsProtocol from './FormsProtocol';
import { HttpHeaders, HttpRequest } from '../../utils/http/Http';
import DSAuth from '../dsAuth/DSAuth';

/**
 * @class which implements logon for advanced gateway authentication
 * @member gatewayUrl - URL of the gateway session
 * @member formsStartPath - start URL of the forms protocol
 */
export default class GatewayAdvancedAuthenticator extends GatewayAuthenticatorBase {
	private gatewayUrl: URL;
	private formsStartPath: string;
	private authenticationData: AuthenticationData;

	constructor(serverUrl: URL, formsStartPath?: string) {
		super(serverUrl);
		this.gatewayUrl = serverUrl;
		this.formsStartPath = formsStartPath;
	}

	/**
	 * Logs on to gateway using the serverUrl and formsStartPath with the forms protocol
	 * @returns Promise<AuthenticationData>
	 */
	public async logon(): Promise<AuthenticationData> {
		const startUrl = new URL(this.gatewayUrl.origin + this.formsStartPath);
		const request = new HttpRequest(
			'GET',
			startUrl,
			new HttpHeaders({
				'Cache-Control': 'no-cache',
				Pragma: 'no-cache',
				Accept:
					gatewayConstants.AUTHENTICATE_RESPONSE +
					',' +
					gatewayConstants.GATEWAY_SESSION_RESPONSE,
				Host: this.gatewayUrl.hostname,
				'X-Citrix-Gateway': this.gatewayUrl.hostname,
				'X-Citrix-AM-LabelTypes': gatewayConstants.LABEL_TYPES,
				'X-Citrix-AM-CredentialTypes': gatewayConstants.CREDENTIAL_TYPES,
			}),
			''
		);
		const formsProtocol = new FormsProtocol(request, this.gatewayUrl);
		this.authenticationData = await formsProtocol.execute();
		return this.authenticationData;
	}

	/**
	 * Logs off the gateway session by sending request to cancel postback url
	 */
	public async logoff(): Promise<void> {
		await DSAuth.getInstance().fetch(
			'GET',
			this.gatewayUrl.origin + this.authenticationData.authdata.get('LogOff'),
			{
				Accept:
					gatewayConstants.AUTHENTICATE_RESPONSE +
					',' +
					gatewayConstants.GATEWAY_SESSION_RESPONSE,
				Host: this.gatewayUrl.hostname,
				'x-Citrix-Gateway': this.gatewayUrl.hostname,
				'X-Citrix-AM-LabelTypes': gatewayConstants.LABEL_TYPES,
				'X-Citrix-AM-CredentialTypes': gatewayConstants.CREDENTIAL_TYPES,
				'Cache-Control': 'no-cache',
				Pragma: 'no-cache',
				Connection: 'Close',
			},
			'',
			'',
			false,
			''
		);
	}

	getGatewayUrl(): URL {
		return this.gatewayUrl;
	}
}
